var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearFilled = function SvgClearFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 2,
    y: 2,
    fill: "#fff",
    rx: 8.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7F848E",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M12.5 7.5 10 10m0 0-2.5 2.5M10 10l2.5 2.5M10 10 7.5 7.5M18.333 10a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Z"
  })));
};
export default SvgClearFilled;